import axios from 'axios';

const reqUrl = process.env.NEXT_PUBLIC_RELEVANCE_SPO_API_URL;

async function createSpo({ objective, region }: { objective: string; region: string }) {
  const { data } = await axios.post(`${reqUrl}/trigger_limited_async`, {
    params: {
      overall_objective: objective,
      target_region: region,
    },
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    studio_id: '12847c11-b90f-4808-813a-0fb139184837',
  });
  return data;
}

async function getSpo({ jobId }: { jobId: string }) {
  const params = {
    ending_update_only: false,
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    sort: '[{"message_id":"desc"}]',
  };
  const { data } = await axios.get(`${reqUrl}/async_poll/${jobId}`, { params });
  return data;
}

export const spos = {
  createSpo,
  getSpo,
};
